import { Platform } from 'react-native';
import * as FileSystem from 'expo-file-system';

const memoryStore: Record<string, string> = {};
const storageFile = FileSystem.documentDirectory ? `${FileSystem.documentDirectory}ebook-storage.json` : null;
let hydrated = false;

function browserStorage() {
  return typeof globalThis !== 'undefined' && 'localStorage' in globalThis
    ? globalThis.localStorage
    : undefined;
}

async function persistNativeStore() {
  if (!storageFile || Platform.OS === 'web') return;
  await FileSystem.writeAsStringAsync(storageFile, JSON.stringify(memoryStore));
}

export async function hydrateDeviceStorage() {
  if (hydrated) return;

  const localStorage = browserStorage();
  if (localStorage) {
    Object.keys(localStorage).forEach((key) => {
      const value = localStorage.getItem(key);
      if (value !== null) memoryStore[key] = value;
    });
    hydrated = true;
    return;
  }

  if (storageFile) {
    const info = await FileSystem.getInfoAsync(storageFile);
    if (info.exists) {
      try {
        Object.assign(memoryStore, JSON.parse(await FileSystem.readAsStringAsync(storageFile)));
      } catch {
        await FileSystem.deleteAsync(storageFile, { idempotent: true });
      }
    }
  }

  hydrated = true;
}

export function getStoredItem(key: string) {
  return memoryStore[key] ?? browserStorage()?.getItem(key) ?? null;
}

export async function setStoredItem(key: string, value: string) {
  memoryStore[key] = value;
  browserStorage()?.setItem(key, value);
  await persistNativeStore();
}

export async function removeStoredItem(key: string) {
  delete memoryStore[key];
  browserStorage()?.removeItem(key);
  await persistNativeStore();
}
